/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import advantagesAgreedSectionStyle from "./advantagesAgreedSectionStyle";
import ContainerFullWidth from "../../../Container/ContainerFullWidth";
import Typography from "@mui/material/Typography";

const AdvantagesAgreedSection = () => {
  return (
    <ContainerFullWidth sx={advantagesAgreedSectionStyle.centered}>
      <Typography variant={"h2"} sx={advantagesAgreedSectionStyle.header}>
        Der Vorteil bei einer einvernehmlichen Scheidung: Sie sparen viel Geld und Zeit!
      </Typography>
      <Typography variant={"h4"}>Sie müssen nur einen Anwalt bezahlen</Typography>
      <p>
        Da bei einer einvernehmlichen Scheidung nur der Antragsteller einen Rechtsanwalt beauftragen muss, entfallen die hohen Kosten für den Anwalt des
        Ehepartners komplett.
      </p>
      <br />
      <Typography variant={"h4"}>Ihre Scheidung geht einfach und schnell</Typography>
      <p>
        Sie können jetzt direkt mit Ihrer Scheidung starten. In Ihrer Servicewelt können Sie ganz unkompliziert alle Angaben für den Scheidungsantrag eingeben,
        Ihre individuellen Kosten berechnen und sind jederzeit perfekt informiert.
      </p>
    </ContainerFullWidth>
  );
};

export default AdvantagesAgreedSection;
